import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ScrollArrow from "../../../e-learning-display/components/steps/partial/ScrollArrow";
import EyeClosed from "../EyeClosed";
import EyeOpen from "../EyeOpen";
import { motion } from "framer-motion";
import { saveEventListener } from "../../../util/actions/saveEventListener";
import SpinnerLoader from "../../../e-learning-homepage/components/views/partial/SpinnerLoader";
import Cookies from "js-cookie";

const UserRegister = ({
  dataFromApp,
  setUserState,
  userData,
  setUserData,
  playerId,
  createEmptyPlayer,
}) => {
  const [errors, setErrors] = useState([]);
  const [isPasswordShown, setIsPasswordShown] = useState(false);
  const [isConfirmPasswordShown, setIsConfirmPasswordShown] = useState(false);
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
  const [isRedirected, setIsRedirected] = useState(false);
  const [isPasswordInputFocused, setIsPasswordInputFocused] = useState(false);
  const [passwordValidations, setPasswordValidations] = useState([
    {
      regexp: "(?=.{8,})",
      message: "Składać się z przynajmniej 8 znaków",
    },
    {
      regexp: "(?=.*[a-z])",
      message: "Zawierać małą literę",
    },
    {
      regexp: "(?=.*[A-Z])",
      message: "Zawierać dużą literę",
    },
    {
      regexp: "(?=.*[0-9])",
      message: "Zawierać cyfrę",
    },
  ]);

  const checkPasswordValidation = (regexp, password) => {
    const regex = new RegExp(regexp);

    return regex.test(password);
  };

  const handleSubmit = async () => {
    const submitErrors = [];
    if (!validateEmail(userData.email)) {
      submitErrors.push(["Niepoprawny adres e-mail"]);
    }

    const strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})"
    );
    if (!userData.password.match(strongRegex)) {
      submitErrors.push([
        "Podane hasło musi się składać z 8 znaków, zawierać małą oraz wielką literę, liczbę oraz jeden znak specjalny taki jak *",
      ]);
    }

    // if (userData.password !== userData.passwordRepeat) {
    //   submitErrors.push("Hasła różnią się");
    // }

    if (userData.name.length < 3) {
      submitErrors.push("Imię musi składać się z minimum 3 znaków");
    }

    if (submitErrors.length > 0) {
      setErrors(submitErrors);
      return;
    }

    try {
      const response = await fetch("/anon/check-email", {
        method: "POST",
        body: JSON.stringify({
          email: userData.email,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      });
      const responseData = await response.json();
      if (responseData.status === "error") {
        setErrors(responseData.errors);
      } else {
        if (playerId === 0) {
          createEmptyPlayer("unknown");
        }
        setUserState("register-complete");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleChangeField = (fieldName, event) => {
    if (fieldName === "password") {
      const isAtLeastOneChar = event.target.value.length > 0;
      setIsPasswordInputFocused(isAtLeastOneChar);
    }

    setUserData({ ...userData, ...{ [fieldName]: event.target.value } });
  };

  const togglePasswordShown = () => {
    setIsPasswordShown((prev) => !prev);
  };

  const toggleConfirmPasswordShown = () => {
    setIsConfirmPasswordShown((prev) => !prev);
  };

  const signInHandler = () => {
    setIsRedirected(true);
    Cookies.remove("PHPSESSID");
    window.location.href = "/login";
  };

  useEffect(() => {
    window.addEventListener("mobileEventsContainer", saveEventListener);
    window.addEventListener("beforeunload", (ev) => {
      setIsRedirected(true);
    });

    return () => {
      window.removeEventListener("mobileEventsContainer", saveEventListener);
    };
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  if (isRedirected) return <SpinnerLoader />;

  return (
    <ViewContainer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <ScrollArrow isKeyboardOpen={isKeyboardOpen} />
      <Logo onClick={() => alert(JSON.stringify(dataFromApp))}>
        <img src="/assets/front/img/edustrada/logo-with-text.png" />
      </Logo>
      <TextContent>
        <Text>Cześć!</Text>
        <Text>Zarejestruj się, a następnie wybierz swoją ścieżkę rozwoju!</Text>
      </TextContent>
      <FormContainer>
        {errors.length > 0 && (
          <>
            <div className={"alert alert-danger"}>
              {errors.map((error, index) => {
                return <div key={index}>- {error}</div>;
              })}
            </div>
          </>
        )}
        <input
          value={userData.name}
          onChange={(ev) => handleChangeField("name", ev)}
          className="login-input-text"
          type="text"
          placeholder="Imię"
          maxLength={40}
          onFocus={() => {
            setIsKeyboardOpen(true);
          }}
          onBlur={() => {
            setIsKeyboardOpen(false);
          }}
        />
        <input
          value={userData.email}
          onChange={(ev) => handleChangeField("email", ev)}
          className="login-input-text"
          type="text"
          placeholder="Email"
          onFocus={() => {
            setIsKeyboardOpen(true);
          }}
          onBlur={() => {
            setIsKeyboardOpen(false);
          }}
        />
        <PasswordInputBox>
          <PasswordInput
            value={userData.password}
            onChange={(ev) => handleChangeField("password", ev)}
            className="login-input-text"
            type={isPasswordShown ? "text" : "password"}
            placeholder="Hasło"
            onFocus={(event) => {
              const isAtLeastOneChar = event.target.value.length > 0;
              setIsPasswordInputFocused(isAtLeastOneChar);
              setIsKeyboardOpen(true);
            }}
            onBlur={() => {
              setIsPasswordInputFocused(false);
              setIsKeyboardOpen(false);
            }}
          />
          <PasswordEye onClick={togglePasswordShown}>
            {isPasswordShown ? (
              <EyeClosed id="passwordClosed" />
            ) : (
              <EyeOpen id="passwordOpen" />
            )}
          </PasswordEye>
        </PasswordInputBox>
        {isPasswordInputFocused ? (
          <div className="password-tip">
            <div className="password-tip-wrapper">
              <span className="password-tip-header">Twoje hasło powinno:</span>
              <ul className="password-tip-list">
                {passwordValidations.map((validation, id) => {
                  const isSingleValidationPassed = checkPasswordValidation(
                    validation.regexp,
                    userData.password
                  );

                  let tipPointClassName = "password-tip-point";
                  if (isSingleValidationPassed) {
                    tipPointClassName += " password-tip-point-passed";
                  }

                  return (
                    <li className={tipPointClassName} key={id}>
                      <span>{validation.message}</span>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        ) : null}
        {/* <PasswordInputBox>
          <PasswordInput
            value={userData.passwordRepeat}
            onChange={(ev) => handleChangeField("passwordRepeat", ev)}
            className="login-input-text"
            type={isConfirmPasswordShown ? "text" : "password"}
            placeholder="Powtórz hasło"
            onFocus={() => {
              setIsKeyboardOpen(true);
            }}
            onBlur={() => {
              setIsKeyboardOpen(false);
            }}
          />
          <PasswordEye onClick={toggleConfirmPasswordShown}>
            {isConfirmPasswordShown ? (
              <EyeClosed id="confirmClosed" />
            ) : (
              <EyeOpen id="confirmOpen" />
            )}
          </PasswordEye>
        </PasswordInputBox> */}
      </FormContainer>
      <RegisterButton onClick={handleSubmit}>Zarejestruj się</RegisterButton>
      <SignInContainer>
        <SignInText>
          Masz już konto?{" "}
          <SignInLink onClick={signInHandler}>Zaloguj się!</SignInLink>
        </SignInText>
      </SignInContainer>
      <PrivacyPolicyContainer>
        <PrivacyPolicyText>
          Rejestrując się i używając aplikacji, zgadzasz się na warunki{" "}
          <PrivacyPolicyLink
            href="https://bloomify.app/polityka-prywatnosci/"
            target="_blank"
          >
            polityki prywatności
          </PrivacyPolicyLink>{" "}
          i{" "}
          <PrivacyPolicyLink
            href="https://bloomify.app/regulamin/"
            target="_blank"
          >
            regulamin
          </PrivacyPolicyLink>
          .
        </PrivacyPolicyText>
      </PrivacyPolicyContainer>
    </ViewContainer>
  );
};

export default UserRegister;

const PrivacyPolicyContainer = styled.div`
  margin-top: 20px;
`;

const Logo = styled.div`
  display: flex;
  justify-content: center;
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 40px 0;
`;

const Text = styled.div`
  text-align: center;
  color: #fff;
  font-size: 20px;
  font-weight: 300;
  line-height: 25px;
`;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 40px;
  width: 100%;
`;

const RegisterButton = styled.button`
  width: 100%;
  text-align: center;
  background-color: #fff;
  color: #0d132a;
  border: none;
  border-radius: 40px;
  font-weight: bold;
  padding: 10px 0;
  font-size: 18px;
`;

const SignInContainer = styled(PrivacyPolicyContainer)``;

const PrivacyPolicyText = styled.p`
  color: #fff;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  margin-bottom: 0;
`;

const SignInText = styled(PrivacyPolicyText)`
  margin: 0;
  font-weight: 600;
  font-size: 16px;
`;

const PrivacyPolicyLink = styled.a`
  text-decoration: underline;

  &:link,
  &:visited,
  &:focus,
  &:hover,
  &:active {
    color: #fff;
  }
`;

const SignInLink = styled(PrivacyPolicyLink)``;

const PasswordInputBox = styled.div`
  position: relative;
`;

const PasswordInput = styled.input`
  padding-right: 57px;
`;

const PasswordEye = styled.div`
  position: absolute;
  width: 57px;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    fill: #fff;
  }
`;

const ViewContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  padding: 55px 30px 30px 30px;
  background-image: url("/assets/front/img/edustrada/login-bg.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  display: flex;
  min-height: 100%;
  align-items: center;
  justify-content: center;
`;
